import { useState } from "react";

import { i18n } from "../../translate/i18n";

import Modal from "react-modal/lib/components/Modal";

import './styles.css';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";

import Share from "../../assets/icons/share.png";
import More from "../../assets/photos/foto-capa-modal-morepost.png";

//modal imports

import Postevent from "../../assets/photos/projects/postevent/post-event.png";
import Postevent1 from "../../assets/photos/projects/postevent/postevent-project-one.png";
import Postevent2 from "../../assets/photos/projects/postevent/postevent-project-desktop.png";
import Postevent3 from "../../assets/photos/projects/postevent/postevent-project-mobile.png";

import Lojas from "../../assets/photos/projects/lojas/1.png";
import Lojas1 from "../../assets/photos/projects/lojas/2.png";
import Lojas2 from "../../assets/photos/projects/lojas/3.png";
import Lojas3 from "../../assets/photos/projects/lojas/4.png";

import Portfolio from "../../assets/photos/projects/portfolio/portfolio-capa.png";
import Portfolio1 from "../../assets/photos/projects/portfolio/portfolio-project-one.png";
import Portfolio2 from "../../assets/photos/projects/portfolio/portfolio-project-desktop.png";
import Portfolio3 from "../../assets/photos/projects/portfolio/portfolio-project-mobile.png";

import Alpes from "../../assets/photos/projects/alpes/alpes.png";
import Alpes_logo from "../../assets/photos/projects/alpes/alpes-logo.webp";
import Alpes_desk from "../../assets/photos/projects/alpes/alpes-desk.webp";
import Alpes_mobile from "../../assets/photos/projects/alpes/alpes-mobile.webp";

import Jeep from "../../assets/photos/projects/jeep/jeep.png"
import Jeep_logo from "../../assets/photos/projects/jeep/jeep-capa.jpg"
import Jeep_desk from "../../assets/photos/projects/jeep/jeep-desk.webp"
import Jeep_mobile from "../../assets/photos/projects/jeep/jeep-mobile.jpg"

import Toy from "../../assets/photos/projects/toystorymemory/minecraft.png"
import Toy_logo from "../../assets/photos/projects/toystorymemory/portfolio-project-one.jpg"
import Toy_desk from "../../assets/photos/projects/toystorymemory/desk-mockp-portfolio.jpg"
import Toy_mobile from "../../assets/photos/projects/toystorymemory/mobile-mockp-portfolio.jpg"

import Tatuape from "../../assets/photos/projects/tatuape/tatu.png"
import Tatuape_logo from "../../assets/photos/projects/tatuape/portfolio-project-one.png"
import Tatuape_desk from "../../assets/photos/projects/tatuape/desk-mockp-portfolio.png"
import Tatuape_mobile from "../../assets/photos/projects/tatuape/mobile-mockp-portfolio.png"

Modal.setAppElement("#root");

export const Projects = () => {

    const [modalOneIsOpen, setOneIsOpen] = useState(false);
    const [modalTwoIsOpen, setTwoIsOpen] = useState(false);
    const [modalTreIsOpen, setTreIsOpen] = useState(false);
    const [modalFiveIsOpen, setFiveIsOpen] = useState(false);
    const [modalSixIsOpen, setSixIsOpen] = useState(false);
    const [modalSevenIsOpen, setSevenIsOpen] = useState(false);
    const [modalEightIsOpen, setEightIsOpen] = useState(false);



    function openModalOne() {
        setOneIsOpen(true);
    }

    function closeModalOne() {
        setOneIsOpen(false);
    }

    function openModalTwo() {
        setTwoIsOpen(true);
    }

    function closeModalTwo() {
        setTwoIsOpen(false);
    }

    function openModalTre() {
        setTreIsOpen(true);
    }

    function closeModalTre() {
        setTreIsOpen(false);
    }

    function openModalFive() {
        setFiveIsOpen(true);
    }

    function closeModalFive() {
        setFiveIsOpen(false);
    }

    function openModalSix() {
        setSixIsOpen(true);
    }

    function closeModalSix() {
        setSixIsOpen(false);
    }

    function openModalSeven() {
        setSevenIsOpen(true);
    }

    function closeModalSeven() {
        setSevenIsOpen(false);
    }

    function openModalEight() {
        setEightIsOpen(true);
    }

    function closeModalEight() {
        setEightIsOpen(false);
    }
    const lojas = [
        { nome: "Gangster", url: "https://gangster.convertr.app.br/" },
        { nome: "Kenndra", url: "https://kenndra.convertr.app.br/" },
        { nome: "Ecosmetal", url: "https://ecosmetal.convertr.app.br/" },
        { nome: "Rhinosize", url: "https://rhinosize.convertr.app.br/" },
        { nome: "Efflore", url: "https://efflore.convertr.app.br/" },
        { nome: "Wiegand", url: "https://wiegandstore.convertr.app.br/" },
        { nome: "Customic", url: "https://customic.convertr.app.br/" },
        { nome: "Baby Joy", url: "https://lojababyjoy.convertr.app.br/" },
        { nome: "Mar quente", url: "https://marquente.convertr.app.br/" },
        { nome: "Freecorner", url: "https://freecorner.convertr.app.br/" },
    ];
    return (
        <>
            <span id="projects"></span>
            <div className="container-projects">
                <div className="txt-projects">
                    <div className="p-title">{i18n.t('projects.project')}</div>
                    <h4>{i18n.t('projects.development')}</h4>
                </div>
                <div className="grid-projects">
                    <div className="project">
                        <img src={Lojas} alt="Lojas" />
                        <div className="drop">
                            <div className="text">
                                <button onClick={openModalOne} className="btn-down"><p>{i18n.t('projects.seemore')}</p></button>
                                <Modal
                                    isOpen={modalOneIsOpen}
                                    onRequestClose={closeModalOne}
                                    contentLabel="Modal Example"
                                    overLayClassName="modal-overlay"
                                    className="modal-content"
                                >
                                    <Swiper
                                        pagination={{
                                            clickable: true,
                                        }}
                                        navigation={true}
                                        loop={true}
                                        slidesPerView={1}
                                        autoplay={{ delay: 5000 }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        <SwiperSlide><img src={Lojas1} alt="mockup site logo" /></SwiperSlide>
                                        <SwiperSlide><img src={Lojas2} alt="mockup site desktop" /></SwiperSlide>
                                        <SwiperSlide><img src={Lojas3} alt="mockup site mobile" /></SwiperSlide>
                                    </Swiper>
                                    <h4>Desenvolvimento de E-commerces</h4>

                                    <span>{i18n.t('projects.text_dev')}<a href="https://convertr.com.br/" target='_blank' rel="noopener noreferrer">Convertr Commerce</a> </span>
                                    <hr />
                                    <div className="skill-camp">
                                        <div className="skill-box">
                                            <span>Java Script</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>HTML 5</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>CSS 3</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Vue.js</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Visual Studio Code</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>SEO</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Figma</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Git</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Bitbucket</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Plataforma da empresa</span>
                                        </div>
                                    </div>
                                    <div className="content__stores">
                                        {lojas.map((loja, index) => (
                                            <div className="content-link" key={index}>
                                                <a href={loja.url} target='_blank' rel='noreferrer'>
                                                    {loja.nome}
                                                </a>
                                                <img className="share" src={Share} alt="Share" />
                                            </div>
                                        ))}
                                        <span className="more">+35 stores</span>
                                    </div>
                                    <button onClick={closeModalOne}><p>{i18n.t('projects.modal_button')}</p></button>
                                    <span className="version">{i18n.t('projects.modal_warning2')}</span>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="project">
                        <img src={Portfolio} alt="Portfolio" />
                        <div className="drop">
                            <div className="text">
                                <button onClick={openModalTwo} className="btn-down"><p>{i18n.t('projects.seemore')}</p></button>
                                <Modal
                                    isOpen={modalTwoIsOpen}
                                    onRequestClose={closeModalTwo}
                                    contentLabel="Modal Example"
                                    overLayClassName="modal-overlay"
                                    className="modal-content"
                                >
                                    <Swiper
                                        pagination={{
                                            clickable: true,
                                        }}
                                        navigation={true}
                                        loop={true}
                                        slidesPerView={1}
                                        autoplay={{ delay: 5000 }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        <SwiperSlide><img src={Portfolio1} alt="mockup site logo" /></SwiperSlide>
                                        <SwiperSlide><img src={Portfolio2} alt="mockup site desktop" /></SwiperSlide>
                                        <SwiperSlide><img src={Portfolio3} alt="mockup site mobile" /></SwiperSlide>
                                    </Swiper>
                                    <h4>Portfolio - Gabriel</h4>
                                    <hr />
                                    <div className="skill-camp">
                                        <div className="skill-box">
                                            <span>Java Script</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>HTML 5</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>CSS 3</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>React</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Visual Studio Code</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>SEO</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>UI</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Photoshop</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Git</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Github</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Netlifly</span>
                                        </div>
                                    </div>
                                    <div className="content-link">
                                        <a href="https://portfoliogabrielgc.netlify.app/" target='_blank' rel='noreferrer' >portfoliogabrielgc.netlify.app</a>
                                        <img className="share" src={Share} alt="" />
                                    </div>
                                    <button onClick={closeModalTwo}><p>{i18n.t('projects.modal_button')}</p></button>
                                    <span className="version">{i18n.t('projects.modal_warning')}</span>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="project">
                        <img src={Postevent} alt="Postevent" />
                        <div className="drop">
                            <div className="text">
                                <button onClick={openModalTre} className="btn-down"><p>{i18n.t('projects.seemore')}</p></button>
                                <Modal
                                    isOpen={modalTreIsOpen}
                                    onRequestClose={closeModalTre}
                                    contentLabel="Modal Example"
                                    overLayClassName="modal-overlay"
                                    className="modal-content"
                                >
                                    <Swiper
                                        pagination={{
                                            clickable: true,
                                        }}
                                        navigation={true}
                                        loop={true}
                                        slidesPerView={1}
                                        autoplay={{ delay: 5000 }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        <SwiperSlide><img src={Postevent1} alt="mockup site logo" /></SwiperSlide>
                                        <SwiperSlide><img src={Postevent2} alt="mockup site desktop" /></SwiperSlide>
                                        <SwiperSlide><img src={Postevent3} alt="mockup site mobile" /></SwiperSlide>
                                    </Swiper>
                                    <h4>Post Event</h4>
                                    <hr />
                                    <div className="skill-camp">
                                        <div className="skill-box">
                                            <span>Java Script</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>HTML 5</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>CSS 3</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>React</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Visual Studio Code</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>SEO</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Fake API for testing</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Netlifly</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Git</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Github</span>
                                        </div>
                                    </div>
                                    <div className="content-link">
                                        <a href="https://postevent.netlify.app/" target='_blank' rel='noreferrer' >postevent.netlify.app</a>
                                        <img className="share" src={Share} alt="" />
                                    </div>
                                    <button onClick={closeModalTre}><p>{i18n.t('projects.modal_button')}</p></button>
                                    <span className="version">{i18n.t('projects.modal_warning')}</span>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="project">
                        <img src={Alpes} alt="Alpes" />
                        <div className="drop">
                            <div className="text">
                                <button onClick={openModalFive} className="btn-down"><p>{i18n.t('projects.seemore')}</p></button>

                                <Modal
                                    isOpen={modalFiveIsOpen}
                                    onRequestClose={closeModalFive}
                                    contentLabel="Modal Example"
                                    overLayClassName="modal-overlay"
                                    className="modal-content"
                                >
                                    <Swiper
                                        pagination={{
                                            clickable: true,
                                        }}
                                        navigation={true}
                                        loop={true}
                                        slidesPerView={1}
                                        autoplay={{ delay: 5000 }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        <SwiperSlide><img src={Alpes_logo} alt="mockup site logo" /></SwiperSlide>
                                        <SwiperSlide><img src={Alpes_desk} alt="mockup site desktop" /></SwiperSlide>
                                        <SwiperSlide><img src={Alpes_mobile} alt="mockup site mobile" /></SwiperSlide>
                                    </Swiper>
                                    <h4>Alpes</h4>
                                    <hr />
                                    <div className="skill-camp">
                                        <div className="skill-box">
                                            <span>HTML 5</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>CSS 3</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Photoshop</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Visual Studio Code</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>SEO</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Git</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Github</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>UI</span>
                                        </div>
                                    </div>
                                    <div className="content-link">
                                        <a href="https://alpes.netlify.app/" target='_blank' rel='noreferrer' >alpes.netlify.app</a>
                                        <img className="share" src={Share} alt="" />
                                    </div>
                                    <button onClick={closeModalFive}><p>{i18n.t('projects.modal_button')}</p></button>
                                    <span className="version">{i18n.t('projects.modal_warning')}</span>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="project">
                        <img src={Jeep} alt="Jeep Form" />
                        <div className="drop">
                            <div className="text">
                                <button onClick={openModalSix} className="btn-down"><p>{i18n.t('projects.seemore')}</p></button>

                                <Modal
                                    isOpen={modalSixIsOpen}
                                    onRequestClose={closeModalSix}
                                    contentLabel="Modal Example"
                                    overLayClassName="modal-overlay"
                                    className="modal-content"
                                >
                                    <Swiper
                                        pagination={{
                                            clickable: true,
                                        }}
                                        navigation={true}
                                        loop={true}
                                        slidesPerView={1}
                                        autoplay={{ delay: 5000 }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        <SwiperSlide><img src={Jeep_logo} alt="mockup site logo" /></SwiperSlide>
                                        <SwiperSlide><img src={Jeep_desk} alt="mockup site desktop" /></SwiperSlide>
                                        <SwiperSlide><img src={Jeep_mobile} alt="mockup site mobile" /></SwiperSlide>
                                    </Swiper>
                                    <h4>Jeep Form</h4>
                                    <hr />
                                    <div className="skill-camp">
                                        <div className="skill-box">
                                            <span>HTML 5</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>CSS 3</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Photoshop</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Visual Studio Code</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>SEO</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Git</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Github</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>UI</span>
                                        </div>
                                    </div>
                                    <div className="content-link">
                                        <a href="https://form-totest.netlify.app/" target='_blank' rel='noreferrer' >form-totest.netlify.app</a>
                                        <img className="share" src={Share} alt="" />
                                    </div>
                                    <button onClick={closeModalSix}><p>{i18n.t('projects.modal_button')}</p></button>
                                    <span className="version">{i18n.t('projects.modal_warning')}</span>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="project">
                        <img src={Toy} alt="Toy Story Memory" />
                        <div className="drop">
                            <div className="text">
                                <button onClick={openModalSeven} className="btn-down"><p>{i18n.t('projects.seemore')}</p></button>

                                <Modal
                                    isOpen={modalSevenIsOpen}
                                    onRequestClose={closeModalSeven}
                                    contentLabel="Modal Example"
                                    overLayClassName="modal-overlay"
                                    className="modal-content"
                                >
                                    <Swiper
                                        pagination={{
                                            clickable: true,
                                        }}
                                        navigation={true}
                                        loop={true}
                                        slidesPerView={1}
                                        autoplay={{ delay: 5000 }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        <SwiperSlide><img src={Toy_logo} alt="mockup site logo" /></SwiperSlide>
                                        <SwiperSlide><img src={Toy_desk} alt="mockup site desktop" /></SwiperSlide>
                                        <SwiperSlide><img src={Toy_mobile} alt="mockup site mobile" /></SwiperSlide>
                                    </Swiper>
                                    <h4>Toy Story Memory</h4>
                                    <span>versão atualizada para o tema de Mincraft</span>
                                    <hr />
                                    <div className="skill-camp">
                                        <div className="skill-box">
                                            <span>HTML 5</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>CSS 3</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Photoshop</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Visual Studio Code</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>JavaScript</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Github</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>UI</span>
                                        </div>
                                    </div>
                                    <div className="content-link">
                                        <a href="https://projectmemorycards.netlify.app/" target='_blank' rel='noreferrer' >projectmemorycards.netlify.app</a>
                                        <img className="share" src={Share} alt="" />
                                    </div>
                                    <button onClick={closeModalSeven}><p>{i18n.t('projects.modal_button')}</p></button>
                                    <span className="version">{i18n.t('projects.modal_warning')}</span>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="project">
                        <img src={Tatuape} alt="Toy Story Memory" />
                        <div className="drop">
                            <div className="text">
                                <button onClick={openModalEight} className="btn-down"><p>{i18n.t('projects.seemore')}</p></button>

                                <Modal
                                    isOpen={modalEightIsOpen}
                                    onRequestClose={closeModalEight}
                                    contentLabel="Modal Example"
                                    overLayClassName="modal-overlay"
                                    className="modal-content"
                                >
                                    <Swiper
                                        pagination={{
                                            clickable: true,
                                        }}
                                        navigation={true}
                                        loop={true}
                                        slidesPerView={1}
                                        autoplay={{ delay: 5000 }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        <SwiperSlide><img src={Tatuape_logo} alt="mockup site logo" /></SwiperSlide>
                                        <SwiperSlide><img src={Tatuape_desk} alt="mockup site desktop" /></SwiperSlide>
                                        <SwiperSlide><img src={Tatuape_mobile} alt="mockup site mobile" /></SwiperSlide>
                                    </Swiper>
                                    <h4>PROJETO TESTE - Tatuapé</h4>
                                    <hr />
                                    <div className="skill-camp">
                                        <div className="skill-box">
                                            <span>HTML</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>CSS</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Photoshop</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Visual Studio Code</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>JavaScript</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>Github</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>UI</span>
                                        </div>
                                        <div className="skill-box">
                                            <span>SEO</span>
                                        </div>
                                    </div>
                                    <div className="content-link">
                                        <a href="https://tatuapeconceito-front.netlify.app/" target='_blank' rel='noreferrer' >tatuapeconceito-front.netlify.app</a>
                                        <img className="share" src={Share} alt="" />
                                    </div>
                                    <button onClick={closeModalEight}><p>{i18n.t('projects.modal_button')}</p></button>
                                    <span className="version">{i18n.t('projects.modal_warning')}</span>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="project">
                        <div className="more">
                            <img src={More} alt="More" />
                        </div>
                    </div>


                </div>
            </div >
            <hr />
        </>
    );
}